import { TopicSource } from 'app/copied/constants/common';
import useSelectedIsSuggested from 'app/hooks/analytics/useSelectedIsSuggested';
import usePreviousPathname from 'app/hooks/usePreviousPathname';
import { useMemo } from 'react';

const useTopicSource = (): TopicSource => {
  const { currentPathname, previousPathname } = usePreviousPathname();
  const [selectedIsSuggested] = useSelectedIsSuggested();
  const pathToCompare = currentPathname === '/tailor/article' ? previousPathname : currentPathname;
  const fromLanding = pathToCompare === '/tailor';
  const fromCategory = pathToCompare.includes('/tailor/category');

  const topicSource = useMemo(() => {
    if (fromLanding) {
      return TopicSource.LandingPage;
    } else if (fromCategory) {
      return TopicSource.CategoryPage;
    } else if (selectedIsSuggested) {
      return TopicSource.Suggested;
    } else {
      return TopicSource.SearchResult;
    }
  }, [fromLanding, selectedIsSuggested, fromCategory]);

  return topicSource;
};

export default useTopicSource;
